import {AppStoreState} from '../interfaces/app-store-state';
import {createReducer, on} from '@ngrx/store';
import {reset, setCommonData, setPageTitle, updateCrmInstanceId, updateInstanceId} from './app-actions';

const initialState: AppStoreState = {
  commonData: undefined,
  pageTitle: undefined,
};

export const appReducer = createReducer(
  initialState,
  on(setCommonData, (state, {commonData}) => ({...state, commonData})),
  on(setPageTitle, (state, {title}) => ({...state, pageTitle: title})),
  on(updateInstanceId, (state, {instanceId}) => {
    if (state.commonData && state.commonData.user && instanceId !== undefined) {
      return ({
        ...state,
        commonData: {
          ...state.commonData,
          user: {
            ...state.commonData.user,
            instance_id: instanceId
          }

        }
      })
    } else {
      return {...state}
    }
  }),
  on(updateCrmInstanceId, (state, {crmId}) => {
    if (state.commonData && state.commonData.user && crmId !== undefined) {
      return ({
        ...state,
        commonData: {
          ...state.commonData,
          user: {
            ...state.commonData.user,
            crm_id: crmId
          }

        }
      })
    } else {
      return {...state}
    }
  }),
  on(reset, state => ({
    ...initialState,
    commonData: {
      is_authorized: false,
      user: null,
      user_info: null,
      captcha_error: null,
      captcha_required: null,
    }
  })),
);
